module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.autocompleteText),
      expression: "autocompleteText"
    }],
    ref: "autocomplete",
    class: _vm.classname,
    attrs: {
      "type": "text",
      "id": _vm.id,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.autocompleteText)
    },
    on: {
      "focus": function($event) {
        _vm.onFocus()
      },
      "blur": function($event) {
        _vm.onBlur()
      },
      "change": _vm.onChange,
      "keypress": _vm.onKeyPress,
      "keyup": _vm.onKeyUp,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.autocompleteText = $event.target.value
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-548d2db4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=ygg9q74r7h!./~/vue-google-autocomplete/src/VueGoogleAutocomplete.vue
// module id = 428
// module chunks = 2